const ContentPagesSvg = ({
  height = 22,
  width = 22,
  viewBox = '0 0 24 24',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox}>
      <path
        d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM13 3.5L18.5 9H14C13.45 9 13 8.55 13 8V3.5ZM8 13H16V15H8V13ZM8 17H16V19H8V17ZM8 9H11V11H8V9Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ContentPagesSvg;
